<template>
  <div class="page-content">
    <page-template
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      :addColumns="addColumns"
      :editColumns="editColumns"
    ></page-template>
    <el-dialog title="分配权限" :visible.sync="allot" width="600px" height="500px" :close-on-click-modal="false">
      <menu-tree-template ref="menuTree" :treeConfig="treeConfig"></menu-tree-template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitAuth" type="primary">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="店小二权限分配" :visible.sync="appletShow" width="600px" height="500px" :close-on-click-modal="false">
      <menu-tree-template ref="appletMenuTree" :treeConfig="appletTreeConfig"></menu-tree-template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="appletSave" type="primary">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import menuTreeTemplate from "@/components/business/menuTreeTemplate";

export default {
  components: {
    pageTemplate,
    menuTreeTemplate
  },
  data() {
    return {
      appletShow:false,
      allot: false,
      treeConfig: {
        id: 'menuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: api.system.rolePrivilege,
          param: {id: ''}
        }
      },
      appletTreeConfig: {
        id: 'appletMenuTree',
        showCheckbox: true,
        data: [],
        nodeKey: 'id',
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        request: {
          api: '/api/eros/wa/waMenu/privilege',
          param: {id: ''}
        }
      },
      // 高级搜索条件
      searchOptions: {
        simple: [
          {label: "角色名称", prop: "name", ifFuzzy: true, type: "input"},
          {label: "编码", prop: "code", type: "input"},
        ]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert'
        },
        {
          label: '修改',
          code: 'update',
          type: this.$utils.buttonType.tableOperate
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate
        },
        {
          label: '配置权限',
          code: 'permission',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          callback: this.allotMenu
        },
        {
          label: '店小二权限配置',
          code: 'waiter',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          callback: this.appletRole
        }
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          // {
          //   label: '编码',
          //   prop: 'code',
          //   width: '80',
          //   align: 'center',
          // },
          {
            label: '角色名称',
            prop: 'name',
            width: '120',
            align: 'center',
          },
          // {label: '角色类型', prop: 'remarks', width: '120', align: 'center'},
          // {label: '允许授权', prop: '', width: '80', align: 'center'}
        ],
        url: api.system.role,
      },
      // 添加字段
      addColumns: {
        labelWidth: '130px',
        columns: [
          {
            label: '角色名称',
            type: 'input',
            prop: 'name',
            rule: [
              {required: true, message: '请输入名称', trigger: 'blur'},
              {
                min: 2,
                max: 15,
                message: '长度在 2 到 15 个字符',
                trigger: 'blur'
              }
            ],
            span: 12
          },
          {
            label: '角色编号',
            type: 'input',
            prop: 'code',
            span: 12
          },
          {
            label: '角色类型',
            type: 'input',
            prop: 'roleType',
            isShow: false,
            defaultValue: 19910,
            span: 12
          },
        ],
        url: api.system.role
      },
      // 编辑
      editColumns: {
        labelWidth: '130px',
        columns: [
          {
            label: '角色名称',
            type: 'input',
            prop: 'name',
            rule: [
              {required: true, message: '请输入名称', trigger: 'blur'},
              {
                min: 2,
                max: 15,
                message: '长度在 2 到 15 个字符',
                trigger: 'blur'
              }
            ],
            span: 12
          },
          {
            label: '角色编号',
            type: 'input',
            prop: 'code',
            span: 12
          },
        ],
        url: api.system.role
      },
    };
  },
  created() {
  },
  methods: {
    // 点击小程序分配权限
    appletRole(val){
      //appletMenuTree
      console.log(val)
      this.appletShow = true
      this.appletTreeConfig.request.param.id = val.id;
      this.$nextTick(() => {
        this.$refs.appletMenuTree.getTreeData();
      });
    },
    //小程序权限提交
    appletSave(){
      this.$refs.appletMenuTree.loading = true;
      this.$axios.fetchPost('/api/eros/wa/waMenu/privilege', {
        privilegeIds: this.$refs.appletMenuTree.getCheckedIds(),
        id: this.appletTreeConfig.request.param.id
      }).then(data => {
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '提交操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功!'});
          this.appletShow = false;
        } else {
          this.$message({message: data.msg, type: 'error'});
        }
      });
    },

    //分配权限
    allotMenu(data) {
      this.allot = true;
      this.treeConfig.request.param.id = data.id;
      this.$nextTick(() => {
        this.$refs.menuTree.getTreeData();
      });
    },

    //提交权限
    submitAuth() {
      this.$refs.menuTree.loading = true;
      this.$axios.fetchPost(api.system.rolePrivilege, {
        privilegeIds: this.$refs.menuTree.getCheckedIds(),
        id: this.treeConfig.request.param.id
      }).then(data => {
        if (data.code === 200) {
          this.$notify({
            type: "success",
            title: '提交操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({type: 'success', message: '操作成功!'});
          this.allot = false;
        } else {
          this.$message({message: data.msg, type: 'error'});
        }
      });
    }
  }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/system/maintain/Role.vue